// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "page__gap-3PaCm";
var _5 = "block__gap-3necP";
var _6 = "elements__gap-SFpCA";
var _7 = "wrapper-1ScQ-";
var _8 = "homeUserCard-W0iXy";
var _9 = "nextFlight-3Yfeh";
var _a = "link-3UcxV";
var _b = "warning-3dngL";
var _c = "loginWrapper-3gPwb";
var _d = "active__route-1DN5g";
var _e = "route__title-1xZBj";
var _f = "container-1r8D2";
var _10 = "contacts__title-1XXHX";
var _11 = "footer-2pMsp";
var _12 = "profileControls-XSvSh";
var _13 = "tabs__flexContainer-3eNp0";
var _14 = "tab-3vW7k";
var _15 = "tabLabel-3Z6fs";
var _16 = "tabSelected-VKp-s";
var _17 = "orders__header-1AtuC";
var _18 = "tabs-a_d0r";
var _19 = "tabs__container-To5LY";
var _1a = "tabIndicator-2jhwD";
var _1b = "pagination-1EgSZ";
var _1c = "mobileSidebar-h0N4C";
var _1d = "mobileSidebar__hide-35es9";
var _1e = "orderStub-1XeKo";
var _1f = "active__route__communications-1WBSE";
var _20 = "account__fullscreen-1eJlK";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "page__gap", _5 as "block__gap", _6 as "elements__gap", _7 as "wrapper", _8 as "homeUserCard", _9 as "nextFlight", _a as "link", _b as "warning", _c as "loginWrapper", _d as "active__route", _e as "route__title", _f as "container", _10 as "contacts__title", _11 as "footer", _12 as "profileControls", _13 as "tabs__flexContainer", _14 as "tab", _15 as "tabLabel", _16 as "tabSelected", _17 as "orders__header", _18 as "tabs", _19 as "tabs__container", _1a as "tabIndicator", _1b as "pagination", _1c as "mobileSidebar", _1d as "mobileSidebar__hide", _1e as "orderStub", _1f as "active__route__communications", _20 as "account__fullscreen" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "page__gap": _4, "block__gap": _5, "elements__gap": _6, "wrapper": _7, "homeUserCard": _8, "nextFlight": _9, "link": _a, "warning": _b, "loginWrapper": _c, "active__route": _d, "route__title": _e, "container": _f, "contacts__title": _10, "footer": _11, "profileControls": _12, "tabs__flexContainer": _13, "tab": _14, "tabLabel": _15, "tabSelected": _16, "orders__header": _17, "tabs": _18, "tabs__container": _19, "tabIndicator": _1a, "pagination": _1b, "mobileSidebar": _1c, "mobileSidebar__hide": _1d, "orderStub": _1e, "active__route__communications": _1f, "account__fullscreen": _20 }
